import api from "@/config/api";
import { Params } from "@/types/utils";
import { log } from "@/utils/logger";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useParams } from "react-router-dom";

type AccountingTransactionAttachmentResponse = {
    url: string;
    expiresAt: string;
    filename: string;
    contentType: string;
};
type AttachmentMode = "preview" | "download";

const useQueryAccountingTransactionAttachment = () => {
    const { oid, sid, rid } = useParams<Params>();
    const queryClient = useQueryClient();

    const fetchAccountingTransactionAttachment = useCallback(
        async (tid: string | number, mode: AttachmentMode = "download") => {
            if (!oid || !sid || !rid) return;

            return queryClient.fetchQuery({
                queryKey: ["accounting-transaction-attachment", oid, sid, rid, tid, mode],
                queryFn: async () => {
                    try {
                        const data = await api.get<AccountingTransactionAttachmentResponse>(
                            `/organizations/${oid}/submissions/${sid}/reports/${rid}/shared/transaction/${tid}/attachment?mode=${mode}`,
                            { timeoutMs: 300000 },
                        );
                        return data;
                    } catch (e) {
                        log.error(e);
                    }
                },
            });
        },
        [oid, sid, rid, queryClient],
    );

    return { fetchAccountingTransactionAttachment };
};

export default useQueryAccountingTransactionAttachment;
